/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
import type { TranslationKey } from '../models/TranslationKey';

export type DefaultTranslations = Record<keyof typeof TranslationKey, string>;

export const defaultTranslations: DefaultTranslations = {
  update: 'Update',
  updateYourBrowser: 'Update your browser for more security, speed and the best experience on this site.',
  yourBrowserIsOutdated: 'Your web browser ({brow_name}) is out of date.',
};

export const translationsNamespace = 'outdated-browser-info';
